import { defineComponent as _defineComponent } from 'vue';
import PaginationItemsPerPage from "@/components/ui/pagination/PaginationItemsPerPage.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaginatorItemsPerPage',
    props: {
        dataset: { type: null, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const handleItemsPerPageChange = (items) => {
            props.dataset.setItemsPerPage(items);
        };
        const __returned__ = { props, handleItemsPerPageChange, PaginationItemsPerPage };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
